import { useState, useEffect, useRef } from "react";
import { whatsapp } from "../../assets";
import "./FloatingButtons.css";
import { useLocale } from "@/i18n/useLocale";

/**
 * Unico elemento flotante del sitio: el acceso directo a WhatsApp. Antes
 * convivia con una pastilla "Dejanos tu consulta", un popup de salida y el
 * aviso de cookies, y entre los cuatro tapaban el contenido (sobre todo en
 * mobile): el contacto ya tiene su lugar en el navbar y en la seccion de
 * contacto.
 *
 * Montado a nivel de App con key={pathname} para estar en todas las paginas.
 * El key fuerza un remount limpio en cada cambio de pagina -el footer es un
 * nodo distinto en cada una- en vez de arrastrar el estado de docked de la
 * pagina anterior.
 */
function FloatingButtons() {
  const { t } = useLocale();
  const [isDocked, setIsDocked] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  // Mensaje predeterminado: quien hace clic no llega a un chat vacio, ya
  // arranca la conversacion identificado como visita del sitio.
  const whatsappUrl = `https://wa.me/5493413070683?text=${encodeURIComponent(t.footer.whatsappMessage)}`;

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => setIsDocked(entry.isIntersecting));
      },
      {
        threshold: 0,
      }
    );

    const footer = document.querySelector(".footer");
    if (footer) observer.observe(footer);

    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={containerRef}
      className={`floating-container ${isDocked ? "is-docked" : ""}`}
    >
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="floating-wpp"
        aria-label={t.footer.whatsapp}
        title={t.footer.whatsapp}
      >
        <img src={whatsapp} alt="WhatsApp" title="WhatsApp" />
      </a>
    </div>
  );
}

export default FloatingButtons;
